





























































































































import AddressEdit from '@/components/administration/address/AddressEdit.vue'
import CartDetail from '@/components/panier/CartDetail.vue'
import { getDefaultAloAddress } from '@/models/alo/AloAddress'
import { getDefaultAloCommande } from '@/models/alo/AloCommande'
import { AloPanier } from '@/models/alo/AloPanier'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { loadStripe, StripeElements, StripePaymentElement, Stripe as StripeType } from '@stripe/stripe-js'
import cloneDeep from 'clone-deep'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'SessionHistory',
  props: {
    initialStep: {
      type: Number,
      default: 1
    }
  },
  components: { CartDetail, AddressEdit }
})
export default class Profil extends Vue {
  initialStep!: number
  step = 1
  errorFacturation = 'Adresse invalide'
  address = getDefaultAloAddress()
  paying = false
  generatingIntent = false
  stripe!: StripeType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paymentElement: StripePaymentElement | null = null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stripeElements: StripeElements | null = null
  cardError = 'Chargement formulaire paiement'
  commande = getDefaultAloCommande()

  get panier() {
    return this.$store.myGetters.panier
  }

  get postalCode() {
    return this.panier?.address?.adrPostalCode
  }

  @Watch('initialStep')
  onInitialStepChange(newStep: number) {
    this.step = newStep
  }

  @Watch('step')
  onStepChange(newStep: number) {
    this.step = newStep
    if (newStep == 1 && this.$route.name != 'Cart') this.$router.push({ name: 'Cart' })
    if (newStep == 2 && this.$route.name != 'Billing') this.$router.push({ name: 'Billing' })
    if (newStep == 3) {
      if (this.validateAddress()) {
        if (this.$route.name != 'Checkout') this.$router.push({ name: 'Checkout' })
        this.tryGeneratePaiementIntent()
      } else {
        this.step = 2
      }
    }
  }

  created() {
    this.step = this.initialStep
    //@ts-ignore

    this.address = cloneDeep({ ...getDefaultAloAddress(), ...this.panier.address })
  }

  mounted() {}

  remplirAdresseAuto() {
    this.address = cloneDeep({ ...getDefaultAloAddress(), ...this.$store.myGetters.user.address })
  }

  clearPanier() {
    this.$confirm(`Voulez vous vraiment vider votre panier ?`, { title: 'Attention' } as VuetifyConfirmObject).then(
      answer => {
        if (answer) {
          return this.$store.myActions.CLIENT_CLEAR_PANIER()
        }
      }
    )
  }

  tryBuildPaymentElement() {
    if (!this.paymentElement) {
      //@ts-ignore
      this.stripeElements = this.stripe.elements({
        clientSecret: this.panier.clientSecret,
        locale: 'fr'
      })
      this.paymentElement = this.stripeElements.create('payment')
      this.paymentElement.mount('#payment-element')
      this.paymentElement.on('ready', () => {
        this.cardError = ''
      })
    }
  }

  destroyed() {
    if (this.paymentElement) {
      this.paymentElement.unmount()
    }
  }

  udpateQty(payload: { fftId: number; qty: number }) {
    if (payload.qty == 0) {
      this.$confirm(this.$t('Cart.AlertRemoveItem').toString(), {
        title: this.$t('Global.ConfirmDelete'),
        buttonTrueText: this.$t('Global.Yes'),
        buttonFalseText: this.$t('Global.No')
      } as VuetifyConfirmObject).then(response => {
        if (response) {
          this.$store.myActions.CLIENT_UPD_PANIER_ITEM_QTY(payload)
        }
      })
    } else {
      this.$store.myActions.CLIENT_UPD_PANIER_ITEM_QTY(payload)
    }
  }

  isFacturationOk() {
    return !this.panier.address || (this.panier.address.ctyId > 0 && this.panier.address.adrPostalCode.length > 0)
  }

  validateAddress() {
    this.$store.myActions.CLIENT_SET_PANIER_ADDRESS(this.address)
    return (this.$refs.editAddress as AddressEdit).validate()
  }

  tryGeneratePaiementIntent() {
    if (!this.$store.myGetters.isAuthenticated) {
      this.$store.myActions.AUTH_SET_REDIRECT_PATH(this.$route.path)
      this.$router.push({ name: 'Login' })
    } else {
      this.generatingIntent = true
      this.$store.myActions
        .CLIENT_CHECKOUT_REQUEST(this.panier)
        .then(async (panier: AloPanier) => {
          //Tjs AE
          //@ts-ignore
          // this.stripe = Stripe(
          //   'pk_live_51JT7rnBq8tY0RycQFpI7gHncZ7gqApM1M2W6dVf27tCuY9tnMSJyvX9EzYh95c5jkvO58WDnPmOxYt1ykSxwSi3d00owY5k1ek',
          //   { locale: 'fr' }
          // )
          //Tjs AQUADOMIC
          /*this.stripe = await loadStripe(
            'pk_live_51J1tgoLDYR0fjUjlYRXMQhMSD1nLKJ6hBTSD3Meu8aPH7ri3KFNAPLOHBGiD4HgrKZWWySKThySEyye0q2rUUPkm00EWe5phrs',
            { locale: 'fr' }
          )*/
         //Tjs AQUADOMIC AD
          //@ts-ignore
          this.stripe = await loadStripe(
            'pk_live_51TZwZjL49wU1Rk5d5P640AHyzwefmWECqlXF7pVs6TwwUXcNtIse5XgWJNPwJJeLbBxWL6BFMG8zWHV6wxMdhl3q00uRAY4bkC',
            { locale: 'fr' }
          )
          /*if(panier.items.some(i => i.psnId == 20)){          
          //AQUADOMIC AE
          //@ts-ignore 
          //this.stripe = Stripe('pk_test_51JT7rnBq8tY0RycQWscZVTDZsea2WO6N7U3rTtZodyyLXg1nMiRGDcmZRJjqTrTbGU1GYjf46v6OLi9xunWCmPga00wsaiSlYq',{locale: 'fr'})                  
          this.stripe = Stripe('pk_live_51JT7rnBq8tY0RycQFpI7gHncZ7gqApM1M2W6dVf27tCuY9tnMSJyvX9EzYh95c5jkvO58WDnPmOxYt1ykSxwSi3d00owY5k1ek',{locale: 'fr'})       
        }
        else{
          //AQUADOMIC
          //@ts-ignore
          //this.stripe = Stripe('pk_test_51J1tgoLDYR0fjUjl77M9IvORAKls7W1OJQdPjWUNQiFnHqNJP0Cfb74xvTZ8pnrngwkFifkSOjYvu6BxDo2CuPOk00r2OS1kmN',{locale: 'fr'})        
          this.stripe = Stripe('pk_live_51J1tgoLDYR0fjUjlYRXMQhMSD1nLKJ6hBTSD3Meu8aPH7ri3KFNAPLOHBGiD4HgrKZWWySKThySEyye0q2rUUPkm00EWe5phrs',{locale: 'fr'})        
        }*/

          if (this.panier.prixTotal > 0) this.tryBuildPaymentElement()
        })
        .catch(errorMessage => {
          console.log('errorMessage', errorMessage)
          this.$confirm(errorMessage ?? "Une erreur c'est produite merci de retenter", {
            title: 'Problème de génération de votre commande',
            buttonTrueText: this.$t('Global.Ok'),
            buttonFalseText: ''
          } as VuetifyConfirmObject).finally(() => {
            this.step = 1
          })
        })
        .finally(() => {
          this.generatingIntent = false
        })
    }
  }

  checkoutFree() {
    this.$store.myActions
      .CLIENT_CHECKOUT_FREE_REQUEST(this.panier)
      .then((panier: AloPanier) => {
        this.$confirm(
          'Votre commande a bien été prise en compte vous allez recevoir une confirmation par email. Retrouvez vos achats dans votre compte',
          {
            title: 'Commande validée',
            buttonTrueText: this.$t('Global.Ok'),
            buttonFalseText: ''
          } as VuetifyConfirmObject
        ).finally(() => {
          this.$store.myActions.CLIENT_CLEAR_PANIER()
          this.$router.push({ name: 'ProfilAccount' })
        })
      })
      .catch(errorMessage => {
        this.$confirm(
          errorMessage ?? 'Une erreur est survenue lors de la validation merci de rééssayer ou nous contacter.',
          {
            title: 'Erreur lors de la validation de la commande',
            buttonTrueText: this.$t('Global.Ok'),
            buttonFalseText: ''
          } as VuetifyConfirmObject
        )
      })
  }

  checkout() {
    this.paying = true
    //@ts-ignore
    this.stripe
      .confirmPayment({
        elements: this.stripeElements!,
        confirmParams: {
          return_url: `${window.location.origin}${this.$router.resolve({ name: 'ProfilAccount' }).href}`
        },
        redirect: 'if_required'
      })
      .then((result: any) => {
        if (result.error) {
          this.cardError = result.error.message ?? 'Une erreur est survenue lors du paiement'
        } else if (result.paymentIntent?.status === 'succeeded') {
          this.$confirm(
            'Votre paiement a bien été pris en compte vous allez recevoir une confirmation par email. Retrouvez vos achats dans votre compte',
            {
              title: 'Paiement terminé',
              buttonTrueText: this.$t('Global.Ok'),
              buttonFalseText: ''
            } as VuetifyConfirmObject
          ).finally(() => {
            this.$store.myActions.CLIENT_CLEAR_PANIER()
            this.$router.push({ name: 'ProfilAccount' })
          })
        }
      })
      .finally(() => {
        this.paying = false
      })
  }
}
